import React from "react";
import {
  Box,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  Pagination
} from "@mui/material";
import StatusDropdown from "../../../components/StatusDropdown";
import emptyscreen from "../../../assets/Dashboard/emptyscreen.svg";
import CustomText, { textStyles } from '../../../components/CustomText';
import { useTranslation } from "react-i18next";
import { convertUTCToLocalDateTime } from "../../../components/dateTime";
const CompanyMarkersTable = ({ data, page, totalPages, onPageChange }) => {
    const {t} =useTranslation()
    // Debug: Log the data prop
    console.log('PinsTable data:', data);

  return (
    <Box sx={{ mt: 3, border: "1px solid #E6E9EF", borderRadius: 1, p: 1,maxHeight:"450px",overflowY:"auto" }}>
      
      {/* NO DATA */}
      {(!data || data.length === 0) ? (
          <Box sx={{ display: 'flex',flexDirection:"column" ,justifyContent: 'center', alignItems: 'center', height: 300 }}>
          <img src={emptyscreen} alt="No Data" style={{ width: 200,  }} />
            <CustomText
    sx={{
      ...textStyles.h1,
      fontWeight: 500,
      fontSize: '16px',
      color: '#003149',
      pt:1,
    }}
  >
  {t('empty.no_user')}
  </CustomText>

        </Box>
      ) : (
        <Table>
          <TableHead
            sx={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            <TableRow>
              <TableCell sx={HeaderStyles}>{t("tableColumns.id")}</TableCell>
              <TableCell sx={HeaderStyles}>{t("tableColumns.title")}</TableCell>
              <TableCell sx={HeaderStyles}>{t("tableColumns.status")}</TableCell>
              <TableCell sx={HeaderStyles}>{t("tableColumns.legalName")}</TableCell>
              <TableCell sx={HeaderStyles}>{t("tableColumns.adminEmail")}</TableCell>
              <TableCell sx={HeaderStyles}>{t("tableColumns.adminName")}</TableCell>
              <TableCell sx={HeaderStyles}>{t("tableColumns.country")}</TableCell>
              <TableCell sx={HeaderStyles}> {t("tableColumns.createdDate")}</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>

            {data.map((row) => (

              <TableRow key={row.id}>
                <TableCell sx={DataStyles}>{row.id}</TableCell>

                <TableCell sx={DataStyles}>{row.title}</TableCell>

                <TableCell sx={DataStyles}>
                  <Box sx={{ pointerEvents: "none" }}>
                   <StatusDropdown currentStatus={row.company_status}/>
                   
                  </Box>
                </TableCell>

                <TableCell sx={DataStyles}>
                  {row.info?.legalName || "-"}
                </TableCell>

              
                <TableCell sx={DataStyles}>
                  {row.info?.adminEmail || "-"}
                </TableCell>

              
                <TableCell sx={DataStyles}>
                  {row.info?.adminName || "-"}
                </TableCell>

               
                <TableCell sx={DataStyles}>
                  {row.region?.country || "-"}
                </TableCell>

             
         
<TableCell sx={DataStyles}>
  {convertUTCToLocalDateTime(row.created_at)}
</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}

      {/* PAGINATION */}
      <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
        <Pagination
          count={totalPages}
          page={page + 1}
          onChange={(e, value) => onPageChange(value - 1)}
          shape="rounded"
          color="primary"
          size="small"
          sx={{
            "& .MuiPaginationItem-root": {
              fontFamily: "Poppins, sans-serif",
              fontSize: 13,
              fontWeight: 500,
            },
            "& .Mui-selected": {
              backgroundColor: "#E9F3FF",
              color: "#006EC2",
            },
          }}
        />
      </Box>
    </Box>
  );
};

const HeaderStyles = {
  color: "#44546F",
  fontSize: "12px",
  fontFamily: "Poppins, sans-serif",
  fontWeight: 600,
};

const DataStyles = {
  color: "#172B4D",
  fontSize: "12px",
  fontFamily: "Poppins, sans-serif",
  fontWeight: 400,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
};

export default CompanyMarkersTable;
